<template>
  <Layout :tituloPagina="'Network | Perfiles de velocidad'">
    <div class="row">
      <div class="col-lg-5">
        <cmp-secciones seccion="perfiles"></cmp-secciones>
      </div>
    </div>

    <div class="row">
      <div class="col-md-2 col-5">
        <div class="form-check form-switch form-switch-lg mb-3">
          <input
            :checked="activo"
            @change="
              activo = !activo,
              refrescarPerfiles()
            "
            class="form-check-input"
            type="checkbox"
            id="banderaPerfilActivo"
          />
          <label
            class="form-check-label"
            for="banderaPerfilActivo"
          >
            Activos
          </label>
        </div>
      </div>
      <div class="col-md-8 col-7 mb-3">
        <filtrador
          v-on:dato-actualizado="
            dato = $event,
            refrescarPerfiles()
          "
          :datoini="dato"
          placeholder="Datos del perfil de velocidad"
        ></filtrador>
      </div>
      <div class="col-md-2 text-right">
        <router-link
          class="btn btn-success"
          :to="{ name: 'nuevoPerfilVelocidad' }"
        >
          <i class="mdi mdi-plus-thick"></i>
          Nuevo
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 offset-md-8 text-right" style="padding-top: 10px;">
        <span class="badge bg-secondary bg-gradient font-size-12">
          {{nPerfilesEnPag}} perfiles en página
        </span>
        <span class="badge bg-secondary bg-gradient font-size-12">
          {{nPerfilesTotales}} perfiles en total
        </span>
      </div>
    </div>

    <div class="card">
      <div class="card-body" style="min-height: 475px;">
        <div class="table-responsive">
          <table class="table table-hover table-nowrap align-middle" id="tabla-perfiles">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Descarga</th>
                <th>Subida</th>
                <th>Estado</th>
                <th style="width: 180px">Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="perfil in perfiles" :key="perfil.id">
                <td>{{ perfil.nombre }}</td>
                <td>
                  <span v-if="perfil.descarga > 0">
                    {{ perfil.descarga }}
                    {{ perfil.unidad_descarga == 'k' ? 'kbps' : '' }}
                    {{ perfil.unidad_descarga == 'M' ? 'Mbps' : '' }}
                  </span>
                  <span class="badge bg-info bg-gradient font-size-13" v-show="perfil.descarga == 0">
                    Ilimitado
                  </span>
                </td>
                <td>
                  <span v-if="perfil.carga > 0">
                    {{ perfil.carga }}
                    {{ perfil.unidad_carga == 'k' ? 'kbps' : '' }}
                    {{ perfil.unidad_carga == 'M' ? 'Mbps' : '' }}
                  </span>
                  <span class="badge bg-info bg-gradient font-size-13" v-show="perfil.carga == 0">
                    Ilimitado
                  </span>
                </td>
                <td>
                  <span class="badge bg-success bg-gradient font-size-13" v-show="perfil.activo">
                    Activo
                  </span>
                  <span class="badge bg-danger bg-gradient font-size-13" v-show="!perfil.activo">
                    Inactivo
                  </span>
                </td>
                <td>
                  <router-link
                    class="btn btn-warning btn-sm"
                    :to="{
                      name: 'edicionPerfilVelocidad',
                      params: { id: perfil.id }
                    }"
                  >
                    <i class="mdi mdi-square-edit-outline font-size-13"></i>
                    Editar
                  </router-link>

                  <button
                    class="btn btn-danger btn-sm"
                    @click="preguntaEliminar(perfil)"
                  >
                    <i class="mdi mdi-trash-can-outline font-size-13"></i>
                    Eliminar
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="text-center">
      <paginador
        :pag="pagina"
        :totpag="ultimaPagina"
        :epp="porPagina"
        v-on:cargar-pagina="cargarPagina"
        v-on:epp-actualizado="
          porPagina = $event,
          refrescarPerfiles()
        "
      ></paginador>
    </div>
    <br>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/main.vue"
import Paginador from '@/components/Paginador.vue'
import Filtrador from '@/components/Filtrador.vue'
import CmpSecciones from './CmpSecciones.vue'
import PerfilVelocidadCpesSrv from '@/services/PerfilVelocidadCpesSrv.js'
import Swal from 'sweetalert2'
export default {
  name: 'ListadoPerfilesVelocidad',
  components: {
    Layout,
    CmpSecciones, 
    Paginador,
    Filtrador
  },
  data() {
    return {
      dato: '',
      pagina: 1,
      perfiles: [],
      porPagina: parseInt(localStorage.getItem('argusblack.listadoPerfilesVelocidad.por_pagina') || 10),
      ultimaPagina: 1,
      activo: true,
      nPerfilesEnPag:0,
      nPerfilesTotales:0
    }
  },

  created: function() {
    var self = this

    // Carga de Querys
    if (this.$route.query.dato) this.dato = this.$route.query.dato
    if (this.$route.query.activo) this.activo = this.$route.query.activo == 'true' ? true : false
    if (this.$route.query.pagina) this.pagina = parseInt(this.$route.query.pagina)
    if (this.$route.query.por_pagina) this.porPagina = parseInt(this.$route.query.por_pagina)

    // Cargas iniciales
    this.refrescarPerfiles()
  },

  methods: {
    cargarPagina: function(n) {
      this.pagina = n
      this.refrescarPerfiles()
    },

    preguntaEliminar: function(perfil) {
      var self = this

      const swal = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success me-1",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swal.fire({
        title: "Eliminación de perfil",
        html: '¿Está seguro que desea eliminar el perfil <strong>'+perfil.nombre+'</strong>?',
        icon: "warning",
        confirmButtonText: `<i class="mdi mdi-check-bold"></i> Si`,
        cancelButtonText: `<i class="mdi mdi-cancel"></i> No`,
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          PerfilVelocidadCpesSrv.eliminar(perfil.id).then(response => {
            swal.fire("Eliminado!", "Se eliminó correctamente", "success")
            self.refrescarPerfiles()
          }).catch(error => {
            let mensaje
            try {
              mensaje = error.response.data.message
            } catch (e) {
              mensaje = 'No se pudo eliminar el perfil'
            }
            iu.msg.error(mensaje)
            console.log(error)
          })
        } else if ( result.dismiss === Swal.DismissReason.cancel ) {
          swal.fire("Cancelar", "Se canceló la operación correctamente", "error");
        }
      })
    },

    refrescarPerfiles: function() {
      var self = this
      
      iu.spinner.mostrar('#tabla-perfiles')

      // Actualización de los querys
      this.$router.replace({
        query: {
          dato: self.dato,
          activo: self.activo,
          pagina: self.pagina,
          por_pagina: self.porPagina,
        }
      })

      let params = {
        dato: self.dato,
        pagina: self.pagina,
        por_pagina: self.porPagina,
        activo: self.activo
      }

      PerfilVelocidadCpesSrv.perfilesJSON(params).then(response => {
        localStorage.setItem('argusblack.listadoPerfilesVelocidad.por_pagina', self.porPagina)
        let res = response.data
        self.pagina = res.pagina
        self.ultimaPagina = res.ultima_pagina
        self.perfiles = res.perfiles
        self.nPerfilesEnPag = res.nPerfilesEnPag
        self.nPerfilesTotales = res.total
      }).catch(error => {
        let mensaje
        try {
          mensaje = error.response.data.message
        } catch (e) {
          mensaje = 'No se pudieron refrescar los perfiles'
        }
        iu.msg.error(mensaje)
        console.log(error)
      }).finally(() => {
        iu.spinner.ocultar('#tabla-perfiles')
      })
    }
  },
  mounted() {
    iu.spinner.mostrar('#tabla-perfiles')
  }
}
</script>